import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'
import { styled } from '@mui/system'

export const NavBarItems = styled('div')`
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`

export const SidebarSeparator = styled('div')<{ theme?: TTheme }>`
    padding: 16px 14px 6px;
`

export const SeparatorLabel = styled(Typography)`
    letter-spacing: 3px;
`
